import { Typography } from '@mui/material';

import { StlPopup } from '../StlPopup/StlPopup';
import { capitalizeFirstLetter, classNames } from '../utils';

import styles from './StlCreatePopup.module.css';

interface IStlCreatePopup {
  open: boolean;
  timeLabel?: string;
  itemName?: string;
  itemNamePlural?: string;
  handleClose: () => void;
  handleApply: () => void;
  textOverride?: string;
  cancel?: boolean;
  title?: string;
}

export default function StlCreatePopup({
  open,
  timeLabel,
  itemName,
  itemNamePlural,
  handleClose,
  handleApply,
  textOverride,
  cancel = false,
  title = 'Running',
}: IStlCreatePopup) {
  if (!open) return null;

  return (
    <StlPopup
      className={styles.popup}
      btnTxt="Continue"
      title={`${title} ${capitalizeFirstLetter(itemName)}`}
      isOpen={open}
      cancel={cancel}
      onClose={handleClose}
      onApply={handleApply}
    >
      {textOverride ? (
        <Typography className={styles.text} lineHeight="24px">
          {textOverride}
        </Typography>
      ) : (
        <>
          <Typography
            className={classNames(styles.text, styles.textHighlighted)}
          >
            This may take up to {timeLabel}.
          </Typography>
          <Typography className={styles.text} lineHeight="24px">
            You can still explore other {itemNamePlural ?? `${itemName}s`} or
            modules while this {itemName} is processing.
          </Typography>
        </>
      )}
    </StlPopup>
  );
}
